(function(){
  if(window.__gcInit) return; window.__gcInit = true;
  function reveal(root){
    var els=(root||document).querySelectorAll('.gc [data-rv]:not(.is-in), .gc-hl:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target);} });
    },{threshold:.12,rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(e){io.observe(e)});
  }
  function counters(root){
    (root||document).querySelectorAll('[data-count]:not([data-done])').forEach(function(el){
      var io=new IntersectionObserver(function(en){
        if(!en[0].isIntersecting) return; io.disconnect(); el.setAttribute('data-done','1');
        var end=parseFloat(el.getAttribute('data-count'))||0, t0=null, dur=1600;
        function step(t){ if(!t0)t0=t; var p=Math.min((t-t0)/dur,1); var v=Math.round(end*(1-Math.pow(1-p,3))); el.textContent=v.toLocaleString('fr-FR'); if(p<1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      },{threshold:.5}); io.observe(el);
    });
  }
  function filters(root){
    (root||document).querySelectorAll('[data-gc-filter]').forEach(function(wrap){
      if(wrap.__f) return; wrap.__f=1;
      var chips=wrap.querySelectorAll('[data-chip]'), items=wrap.querySelectorAll('[data-type]');
      chips.forEach(function(c){ c.addEventListener('click',function(){
        chips.forEach(function(x){x.classList.remove('is-on');x.setAttribute('aria-pressed','false')});
        c.classList.add('is-on'); c.setAttribute('aria-pressed','true');
        var v=c.getAttribute('data-chip');
        items.forEach(function(it){ var show=(v==='*'||it.getAttribute('data-type')===v); it.style.display=show?'':'none'; if(show){it.classList.remove('is-in'); void it.offsetWidth; it.classList.add('is-in');} });
      });});
    });
  }
  function tilt(root){
    if(window.matchMedia('(hover:none)').matches) return;
    (root||document).querySelectorAll('[data-tilt]').forEach(function(el){
      if(el.__t) return; el.__t=1;
      el.addEventListener('mousemove',function(e){var r=el.getBoundingClientRect();var x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;el.style.transform='perspective(900px) rotateY('+(x*8)+'deg) rotateX('+(-y*8)+'deg)';});
      el.addEventListener('mouseleave',function(){el.style.transform='';});
    });
  }
  function init(root){ reveal(root); counters(root); filters(root); tilt(root); }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',function(){init()});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();